import type { ComponentPropsWithRef, CSSProperties, FC } from 'react';
import clsx from 'clsx';
import styles from './Flex.module.css';

type Props = {
    vertical?: boolean;
    align?: CSSProperties['alignItems'];
    justify?: CSSProperties['justifyContent'];
    flex?: CSSProperties['flex'];
    gap?: CSSProperties['gap'];
} & ComponentPropsWithRef<'div'>;

export const Flex: FC<Props> = ({
    vertical,
    align,
    justify,
    flex,
    gap,
    children,
    className,
    style,
    ...rest
}) => (
    <div
        {...rest}
        className={clsx(styles.flex, className)}
        style={{
            flexDirection: vertical ? 'column' : 'row',
            alignItems: align,
            justifyContent: justify,
            flex,
            gap,
            ...style
        }}
    >
        {children}
    </div>
);
